import React, { Fragment } from 'react'
import { Heading, Paragraph } from '@scentregroup/ui'
import { Link } from 'react-router-dom'
import ExternalLink from '../external-link'
import UtilityBox from '../utility-box'
import UtilityBoxItem from '../utility-box-item'
import { Service } from '../../../types/contentful-v1'
import style from './index.scss'

interface PlanVisitUtilityBoxProps {
  heading: string
  name: string
  address?: string
  address2?: string
  phoneNumber: string
  email: string
  conciergeService?: Service
  centreSlug: string
}

const PlanVisitUtilityBox: React.FunctionComponent<PlanVisitUtilityBoxProps> = ({
  heading,
  name,
  address,
  address2,
  phoneNumber,
  email,
  conciergeService,
  centreSlug,
}) => (
  <UtilityBox>
    {address && (
      <Fragment>
        <Heading type="small" key="heading">
          Address
        </Heading>
        <UtilityBoxItem
          icon="location-drop-pin"
          key="item"
          role="heading"
          aria-label="Store Location"
        >
          <Heading type="extrasmall">{name}</Heading>
          <Paragraph type="medium">{address}</Paragraph>
          {address2 && <Paragraph type="medium">{address2}</Paragraph>}
        </UtilityBoxItem>
      </Fragment>
    )}
    <Heading type="small">{heading}</Heading>
    <UtilityBoxItem icon="phone" role="heading" aria-label="Phone Number">
      <Paragraph type="medium">{phoneNumber}</Paragraph>
    </UtilityBoxItem>
    <UtilityBoxItem icon="email" role="heading" aria-label="Email Address">
      <Paragraph type="medium">
        <ExternalLink url={`mailto:${email}`}>Email us</ExternalLink>
      </Paragraph>
    </UtilityBoxItem>

    {conciergeService && conciergeService.store && (
      <UtilityBoxItem icon="hours">
        <Paragraph type="medium">
          <Link
            to={`/${centreSlug}/service/${conciergeService.sys.id}/${conciergeService.slug}`}
            className={style.conciergeLink}
          >
            View Concierge Hours
          </Link>
        </Paragraph>
      </UtilityBoxItem>
    )}
  </UtilityBox>
)

export default PlanVisitUtilityBox
